import React from "react";

import useMenu from "../hooks/useMenu";

import SchoolMobileMenuItem from "./SchoolMobileMenuItem";

import "./SchoolMobileMenu.css";

const SchoolMobileMenu = () => {
  const { menu } = useMenu();

  return (
    <nav className="school-mobile-menu">
      {menu.map((item) => (
        <SchoolMobileMenuItem
          key={item.id}
          item={item}
        />
      ))}
    </nav>
  );
};

export default SchoolMobileMenu;